import { request as umiRequest } from 'umi';
import { message } from 'antd';
import { setAuth, getAuth } from "./db";

export const post = { method: 'POST' };
export const lang = (navigator.language === 'en' ? 'en-US' : navigator.language) || 'en-US';

/// 环境判断（开发/生产）
const isDev = process.env.NODE_ENV === 'development';

// 环境相关配置
const ENV_CONFIG = {
    // 开发环境配置
    development: {
        baseUrl: '/api', // 使用Umi代理前缀
        credentials: 'same-origin', // 同源凭证
        mode: 'same-origin' // 同源模式
    },
    // 生产环境配置
    production: {
        baseUrl: 'https://www.findtrader.net', // 生产环境域名
        credentials: 'include', // 跨域携带凭证
        mode: 'cors' // 跨域模式
    }
};

// 获取当前环境配置
const { baseUrl, credentials, mode } = ENV_CONFIG[isDev ? 'development' : 'production'];

console.log('process.env.NODE_ENV',process.env.NODE_ENV)

/**
 * http异常
 */
const HttpErrors = {
    401: '登录已过期，请重新登录', // 401不需要提示信息
    403: '无权访问',
    404: '地址不存在',
    405: '非法的接口请求类型',
    409: '账号已在其他设备登录',
    413: '文件过大，请更换文件后重试',
    502: '系统不可用，请稍后重试',
    503: '系统维护升级中，请稍后再进行访问，给您带来不便敬请谅解',
    504: '网关超时',
};
//TODO  status 为空时屏蔽错误信息，主要针对文件流接口，根据业务需求有待调整
const skipErrorMsg = ({ status, request, data, config }) => {
    if (status === 200 && (request?.responseType === 'blob' || config.skipErrorHandler)) {
        return true;
    }
};

const local = localStorage.getItem('umi_locale') || lang;

export const requestConfig = {
    timeout: 60 * 1000,
    timeoutErrorMessage: '网络不稳定，连接超时了',
    headers: {
        'lang': local,
        // 解决CORS问题的关键头
        // 'Content-Type': 'application/json',
        // 'Accept': 'application/json',
    },
    // 跨域请求携带凭证
    // credentials,
    errorConfig: {
        // 错误抛出
        errorThrower: (res) => {
            const { success, status } = res;
            const msg = res.data?.msg;
            // 抛出自制的错误
            if (!success) {
                const error = new Error(msg);
                error.name = 'customError';
                error.info = { status, message: msg };
                throw error;
            }
        },
        // 错误接收及处理

        errorHandler: (error, opts) => {
            const {response, name, info, request} = error || {};
            if (opts?.skipErrorHandler && response?.status === 200) throw error;
            message.destroy('imageLoading');
            // 我们的 errorThrower 抛出的错误。
            if (name === 'customError') {
                const msg = info.data?.msg;
                message.error(msg);
            } else if (response) {
                // Axios 的错误
                // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围
                // message.error(`Response status:${response.status}`);
                if ([401, 409]?.includes(response.status)) {
                    //针对特殊情况屏蔽错误处理
                } else {
                    message.error(HttpErrors[response.status] || '网络不稳定，请稍后再试');
                }
            }
        }},
    requestInterceptors: [
        (url, options) => {
            // 完整URL处理逻辑
            let finalUrl = url;

            // 仅处理非完整URL和非代理路径的请求
            if (!/^(http|\/\/)/i.test(url) && !url.startsWith('/api')) {
                finalUrl = `${baseUrl}${url.startsWith('/') ? url : `/${url}`}`;
            }

            return {
                url,
                options: {
                    ...options,
                    // mode,
                    headers: {
                        ...options?.headers,
                        token:getAuth(),
                        // cors
                    },
                }, }
        },

        // 一个二元组，第一个元素是 request 拦截器，第二个元素是错误处理
        [(url, options) => {return { url, options }}, (error) => {return Promise.reject(error)}],
        // 数组，省略错误处理
        [(url, options) => {return { url, options }}]
    ],
    responseInterceptors: [
        // 直接写一个 function，作为拦截器
        (response) => {
            const { data, headers } = response;
            const auth = data?.data?.token;
            if([401,301,302].includes(data.status) && location.pathname.includes('/account/')){
                message.error(data.msg);
                history.push('/user/login')
            }
            if (auth) {
                setAuth(auth);
            }
            data.success = skipErrorMsg(response);
            return {
                ...response,
                data
            };
        },
    ]
};

export const request = async (url, options)=>{
    let res;
    try{
        res = await umiRequest(url, options);
        if(res.status !== 1){
            message.error(res.msg || '操作异常');
        }
    } catch (e){
        console.info(e);
        res = e?.response?.data;
    }
    return res;
};

export const getApi = async ({api,params,success})=>{
    const response = await api(params);
    if(response?.status){
        success?.();
        return response.data
    }
    message.error(response?.msg || 'eror')
}

/**
 * 轮询指定接口直到满足条件或超时
 * @param {Function} apiFn - 调用接口的函数，需返回 Promise
 * @param {Function} checkFn - 判断结果是否满足条件的函数
 * @param {Object} options - 配置选项
 * @param {number} [options.interval=1000] - 轮询间隔（毫秒）
 * @param {number} [options.timeout=30000] - 超时时间（毫秒）
 * @param {Function} [options.onError] - 错误处理函数
 * @returns {Promise} - 返回一个 Promise，resolve 成功结果，reject 超时或错误
 */
export const pollApi = async (apiFn, checkFn, options = {}) =>{
    const {
        interval = 1000,
        timeout = 30000,
        onError = err => console.error('Polling error:', err)
    } = options;

    let isTimeout = false;
    const timeoutId = setTimeout(() => {
        isTimeout = true;
    }, timeout);

    try {
        while (!isTimeout) {
            try {
                const result = await apiFn();
                if (result.status ==0 || result.status ==1 && result.data ===1){
                    isTimeout = true;
                }
                if (checkFn(result)) {
                    return result;
                }
            } catch (err) {
                onError(err);
            }
            await new Promise(resolve => setTimeout(resolve, interval));
        }
        throw new Error('Polling timed out');
    } finally {
        clearTimeout(timeoutId);
    }
}